import { render, staticRenderFns } from "./IconMail.vue?vue&type=template&id=13d5701e&scoped=true&functional=true&"
import script from "./IconMail.vue?vue&type=script&lang=ts&"
export * from "./IconMail.vue?vue&type=script&lang=ts&"
import style0 from "./IconMail.vue?vue&type=style&index=0&id=13d5701e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "13d5701e",
  null
  
)

export default component.exports